import { render, staticRenderFns } from "./serviceListNew.vue?vue&type=template&id=7f74f450&scoped=true"
import script from "./serviceListNew.vue?vue&type=script&lang=js"
export * from "./serviceListNew.vue?vue&type=script&lang=js"
import style0 from "./serviceListNew.vue?vue&type=style&index=0&id=7f74f450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f74f450",
  null
  
)

export default component.exports